/* eslint-disable import/extensions */
import React, { FC, useEffect } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import ClipListPanel from './components/ClipListPanel/index';
import VideoPlayerPanel from './components/VideoPlayerPanel/index';
import { Colors, Styling, VAULT_VIDEO_TYPE } from '../../constants';
import { updateMediaInformation } from './state/clipperMediaContent';
import VideoProcessingDialog from './components/VideoProcessingDialog/component';
import { IAppState } from '../../state/reducers';
import { StreamStatus } from '../../enums';

const VirtualClipperContainer = styled.div`
  height: calc(100vh - ${Styling.HEADER_HEIGHT}px - var(--impersonation-banner-height, 0px));
  flex: 1;
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 10px 30px 20px 30px;
  background-color: ${Colors.PAPER};
  align-items: center;
`;

const assetIdParam = 'assetId';
const timeStampParam = 'timeStamp';

interface IDispatchProps {
  updateMediaInformation: (assetId: string, timeStamp: number) => void;
}

interface IStateProps {
  assetDetails: any;
}

interface IProps extends IDispatchProps, IStateProps { }

const VirtualClipper: FC<IProps> = (props: IProps) => {
  useEffect(() => {
    const { updateMediaInformation } = props;
    const { location: { search } } = window;
    document.title = 'Clipping';
    const params = new URLSearchParams(search);
    const assetId = params.get(assetIdParam);
    const timeStamp = params.get(timeStampParam);
    updateMediaInformation(assetId, Number.parseFloat(timeStamp));
  }, []);

  const { assetDetails } = props;
  const showVideoProcessingDialog = assetDetails && assetDetails.videoType === VAULT_VIDEO_TYPE.LiveStream
    && (assetDetails.streamStatus === StreamStatus.Live || assetDetails.streamStatus === StreamStatus.Processing);
  return (
    <>
      {showVideoProcessingDialog && (<VideoProcessingDialog />)}
      <VirtualClipperContainer id="VirtualClipper">
        <VideoPlayerPanel />
        <ClipListPanel />
      </VirtualClipperContainer>
    </>
  );
};

const mapDispatchToProps: IDispatchProps = {
  updateMediaInformation,
};

const mapStateToProps = (state: IAppState): IStateProps => ({
  assetDetails: state.clipperMediaContent.assetDetails,
});

export default connect(mapStateToProps, mapDispatchToProps)(VirtualClipper);
